"use client";

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@repo/design-system/components/ui/drop-down-menu";
import { usePrint } from "@repo/design-system/providers/print-provider";
import { ChevronDown, Printer } from "lucide-react";
import { useLanguage } from "~/translations/loader/use-language";
import { Button, type ButtonProps } from "./button-eon";
export function PrintDropdown(t0) {
  const $ = _c(32);
  const {
    asButton,
    variant
  } = t0;
  const t = useLanguage();
  const {
    handlePrint
  } = usePrint();
  if (asButton) {
    let t1;
    if ($[0] !== handlePrint) {
      t1 = () => handlePrint({
        eco: false
      });
      $[0] = handlePrint;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Printer className="size-6 stroke-2" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t.jobad_share_title) {
      t3 = <span className="sr-only">{t.jobad_share_title}</span>;
      $[3] = t.jobad_share_title;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== variant) {
      t4 = <Button className="px-4" onClick={t1} variant={variant}>{t2}{t3}</Button>;
      $[5] = t1;
      $[6] = t3;
      $[7] = variant;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t1;
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Printer className="size-6 stroke-2" />;
    t2 = <ChevronDown className="size-6 stroke-2 duration-200 ease-in-out group-data-[state=open]:rotate-180" />;
    $[9] = t1;
    $[10] = t2;
  } else {
    t1 = $[9];
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t.jobad_share_title) {
    t3 = <span className="sr-only">{t.jobad_share_title}</span>;
    $[11] = t.jobad_share_title;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3 || $[14] !== variant) {
    t4 = <DropdownMenuTrigger asChild={true}><Button className="group" variant={variant}>{t1}{t2}{t3}</Button></DropdownMenuTrigger>;
    $[13] = t3;
    $[14] = variant;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== handlePrint) {
    t5 = () => handlePrint({
      eco: false
    });
    $[16] = handlePrint;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t.jobad_print || $[19] !== t5) {
    t6 = <DropdownMenuItem onClick={t5}>{t.jobad_print}</DropdownMenuItem>;
    $[18] = t.jobad_print;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== handlePrint) {
    t7 = () => handlePrint({
      eco: true
    });
    $[21] = handlePrint;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t.jobad_eco_print || $[24] !== t7) {
    t8 = <DropdownMenuItem onClick={t7}>{t.jobad_eco_print}</DropdownMenuItem>;
    $[23] = t.jobad_eco_print;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t6 || $[27] !== t8) {
    t9 = <DropdownMenuContent align="end" className="">{t6}{t8}</DropdownMenuContent>;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t4 || $[30] !== t9) {
    t10 = <DropdownMenu>{t4}{t9}</DropdownMenu>;
    $[29] = t4;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}